import { Component, OnInit, ViewChild, Output, Input, EventEmitter, Injectable} from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { GlobalService } from '../global-service.service';
import { MatExpansionPanel} from '@angular/material/expansion';
import { MatTabChangeEvent as MatTabChangeEvent} from '@angular/material/tabs';

import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import * as fileSaver from 'file-saver';

@Component({
    selector: 'app-schadenfaelle',
    templateUrl: './schadenfaelle.component.html',
    styleUrls: ['../css/pasura.css'],
    host: { '(document:keyup)': 'onKeyUp($event)' },
    standalone: false
})
export class SchadenfaelleComponent implements OnInit {

  	@ViewChild('panSearch',   		 {static: false}) private panSearch: MatExpansionPanel;
  	
  	meldungVN:any;
  	meldungenTA:any;
  	meldungenTAIDX=0;
  	schadenfaelle:any;
  	schadenfall;
  	editLeistung:any ;
  	showSchadenfall=false;
  	inProgress=false;
  	inProgress2=false;
  	
  	SuchText="";
  	item=0;
  	Suchoptionen=[false,false,false,false,false];
  	displayedColumns =[ 'FallID','Datum','Schadenfall', 'PolicenNr', 'Leistung', 'Halter', 'Pferd'];
  
  	constructor(public globserv: GlobalService, private http:HttpClient, private toastr: ToastrService) { }

  	ngOnInit(): void {
  		
  		this.editLeistung=undefined;
  		
  		this.globserv.getPasuraAction().subscribe((pasuraAction) => {
	      console.log("pasuraAction= " +pasuraAction)
	      if (typeof pasuraAction === 'string')
	      {
		      if (pasuraAction.startsWith('loadSchadenfaellePolice'))
		      {
		      	this.globserv.serverLog("Action -> loadSchadenfaellePolice");
		      	this.showSchadenfall=false;		      	
		      	this.schadenfall=undefined;
		      	var actionArray = pasuraAction.split(';');
		      	this.Suchoptionen=[false,true,false,false,false];
		      	this.sucheSchadenfaelle(actionArray[1]);
		      }else if (pasuraAction.startsWith('closeSchadenfall'))
		      {
		      	this.schadenfaelle=[];
  					this.schadenfall=undefined;
  					//editLeistung:any ;
  					this.showSchadenfall=false;	
		      }
		   }
    	}); 	 
  	}

  onKeyUp(ev:KeyboardEvent) 
  {
  	 
  	 this.inProgress2=false;
    if( this.schadenfall==undefined && ev.keyCode==13)
    {
    	
//    	this.globserv.serverLog("onKeyUp -> loadSchadenfaellePolice");
    	const element = ev.target as HTMLElement;
      if (element.id!='SuchButton')
      {
    		this.sucheSchadenfaelle();
    	}
    }	
  }
  
   sucheSchadenfaelle2(ev)
   {
   	if (ev.clientX >0)
   	{
   		//click mit Maus
   		this.sucheSchadenfaelle();
   		
   	}else if (ev.clientX==0 && (!this.inProgress2))
   	{
   		this.inProgress2=true;
   		this.sucheSchadenfaelle();
   	}
   	console.log("sucheSchadenfaelle", ev , ev.clientX);
   	
   }

  sucheSchadenfaelle(polNr='---')
  {
  		
  		this.inProgress=true;
  		this.schadenfaelle=undefined;
  		this.schadenfall=undefined;
  		
		var data;
		if (polNr=='---')
		{
			data ={"Suche":this.SuchText, Optionen:this.Suchoptionen};
		}else{
			data ={"SuchePoliceNR":polNr, Optionen:this.Suchoptionen};
		}
		
		console.log("sucheSchadenfaelle", data);
		
		var resultData;
		
  		this.globserv.getBackendData("/v1/sucheSchadenfaelle",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim Suchen der Schadenfälle!"}});	
  					 				console.log("Error");
	  					 			console.log(err);  	
	  					 			this.inProgress=false;				 				
  					 		  },
		       () => {
					this.schadenfaelle = resultData.Schadenfaelle;
					this.globserv.anzSchadenfaelle=this.schadenfaelle.length; 
	       		//console.log("Schadenfaelle " +JSON.stringify(this.schadenfaelle));
	       		this.inProgress=false;
			}
			
		);   
  }
  
  selectSchadenfall(row)
  {
  		console.log(JSON.stringify(row));
		this.panSearch.close();
		
		var resultData;
		
  		this.globserv.getBackendData("/v1/getSchadenfall",row).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim Laden des Schadenfadenfalles!"}});	
  					 				console.log("Error");
	  					 			console.log(err);  					 				
  					 		  },
		       () => {
		
					console.log("resultData " +JSON.stringify(resultData));
					//this.meldungenTA=resultData.MeldungenTA;
					
					this.meldungenTAIDX=0;
					this.meldungenTA=resultData.MeldungenTA;
					this.schadenfall=this.meldungenTA[this.meldungenTAIDX];
					
					this.meldungVN=resultData.MeldungVN;
					this.showSchadenfall=true;
					console.log("Schadenfall -> " + JSON.stringify(this.schadenfall));
					//this.loadPolice(row.Daten.Schadenfall.PolicenNr);	       	
		       	
			}
		);   
  }
  
  toggelSuchoptionen(idx)
  {
		this.Suchoptionen[0]=false;
		this.Suchoptionen[1]=false;				
		this.Suchoptionen[2]=false;
		this.Suchoptionen[3]=false;
		this.Suchoptionen[4]=false;
		this.Suchoptionen[idx]=true;
		
		this.globserv.serverLog("toggelSuchoptionen -> loadSchadenfaellePolice");
		this.sucheSchadenfaelle();
  }
  
  loadContact(nr)
  {
		this.globserv.setPasuraAction('loadContact;' + nr +';onlyLoad');  
  }
  
  loadPolice(nr)
  {
  		
		this.globserv.setPasuraAction('loadPolice;' +nr); 
  }
  
 
  
  onDocumentSelected(event)
  {
    	const file:File = event.target.files[0];
    	var myresult;

      if (file) 
      {
				const formData = new FormData();
				formData.append("SchadenfallID", this.schadenfall.SchadenfallID);
            formData.append("Document", file);
            const upload$ = this.http.post("/api/v1/uploadDocument", formData);
            upload$.subscribe(
							result => 
		  					myresult = result,
		  					
		  					err => {
		  					 				console.log("Error");
		  					 		  },
		       () => {
		       		
		       		// this.velos=myresult.Velos;
		       		
		       		this.schadenfall.Daten.Historie= myresult.Historie;
		       		console.log("result ->" +JSON.stringify(myresult));
		       		
		       }
		  ); 
        }
    }
    
    getFile(fileID, fileName)
    {
    	console.log("A");
	    this.globserv.runstatus=='running';
	    console.log("b");
	    this.downloadFile(fileID).subscribe(response => {
				let blob:any = new Blob([response], {  });
				const url = window.URL.createObjectURL(blob);
				//window.open(url);
				//window.location.href = response.url;
				console.log(response);
				this.globserv.runstatus=='';
				fileSaver.saveAs(blob, fileName);
			}), error => console.log('Error downloading the file'),
	                 () => console.info('File downloaded successfully');
	                 
	      console.log("C");
    }
    
    downloadFile(fileID):any
    {	
    	console.log("FileID=" + fileID);
 		return this.http.get("/api/v1/getFile?fileID=" +fileID, {responseType: 'blob'});
 	 }
 	 
	saveLeistung(event)
	{
		if (event)
		{
			var data={"Schadenfall":this.schadenfall};
			var resultData;
			
	  		this.globserv.getBackendData("/v1/saveSchadenfall",data).subscribe(
			result => resultData=result, 
			 	
	  					 err => {
	  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim suchen der Schadenfälle!"}});	
	  					 				console.log("Error");
		  					 			console.log(err);  					 				
	  					 		  },
			       () => {
						
		       		console.log("saveSchadenfall " +JSON.stringify(resultData));
				}
			);   
		}
		this.editLeistung=undefined;			
	} 
	
	addEntschaedigung()
	{
		var data ={"Typ": "Entschaedigung","TimeStamp":this.globserv.formatDate(new Date()),"Positionen":[{"Datum":"", "Diagnose":"", "Betrag":0.0}],"Selbstbehalt":0.0,"Total":0,"Ausbezahlt":false,"Zirkulation":["Paul Fopp","Dr. Urs Iselin","Dr. Rolf Hanimann"]};
		this.schadenfall.Daten.Historie.push(data);
		this.editLeistung=data;
	}	 
	
	deleteHistorie(idx)
	{
		console.log(idx);
		this.schadenfall.Daten.Historie.splice(idx,1);
		this.saveLeistung(true);
	} 	
	
	/*
	
	showToasterDelHistorie_(idx)
	{	
		this.toastr.success("<br /><br /><button type='button' id='confirmationButtonYes' class='btn clear'>Yes</button>",'delete item?',
		{
			closeButton: false,
		   allowHtml: true,
		   onShown: function (toast) {
		   	$("#confirmationButtonYes").click(function(){
		      	console.log('clicked yes');
		      });
		   }
		  });
	}
	*/
	
	

	showToasterDelLeistung(idx)
   {
  
    this.toastr.success("",'Wirklich löschen?',
    {
        closeButton: true,
        enableHtml:false,
        progressBar:true,
        timeOut:6000,
        extendedTimeOut:6000,
        
        
    }).onTap.pipe(take(1)).subscribe(() => this.deleteHistorie(idx));
 
  }
 
 	
	showToasterDelHistorie(idx)
   {
  
    this.toastr.success("",'Wirklich löschen?',
    {
        closeButton: true,
        enableHtml:false,
        progressBar:true,
        timeOut:6000,
        extendedTimeOut:6000,
        
        
    }).onTap.pipe(take(1)).subscribe(() => this.deleteHistorie(idx));
 
  }
  
  getPDFSchadenmeldungTA(idx)
  {
  
 		var data= Object.assign({},this.meldungenTA[this.meldungenTAIDX]);
 		
 		console.log(JSON.stringify(data))		
  		let headers = new HttpHeaders();
		headers = headers.set('Accept', 'application/pdf');

		console.log("idx=" +idx);
		 
		this.http.post("/api/v1/getPDFSchadenmeldungTA/?idx="+idx, data, {responseType: 'blob' 
		 		}).subscribe((response: Blob) => {
            
               fileSaver.saveAs(response, "SchadenmeldungTA_" +data.PolicenNr + "_" +idx+".pdf");
            });
  }

  setMeldungTASchadenfall(data)
  {
  		var resultData;
			
	  	this.globserv.getBackendData("/v1/setMeldungTASchadenfall",data).subscribe(
		result => resultData=result, 
			 	
	  				 err => {
	  				 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim suchen der Schadenfälle!"}});	
	  				 				console.log("Error");
						 			console.log(err);  					 				
	  				 		  },
		       () => {
					
					console.log("setMeldungTASchadenfall " +JSON.stringify(resultData));
					if (resultData.Schadenfaelle!=undefined)
					{
						this.schadenfaelle = resultData.Schadenfaelle;
						this.globserv.anzSchadenfaelle=this.schadenfaelle.length; 
					}else{
						this.schadenfaelle =[];
						this.globserv.anzSchadenfaelle=0;
					}
			}
		);   
  }  
  
  async showDocument(element)
  {
		var data=element;
		//this.workerWait=true;
		console.log("element ->  " +JSON.stringify(data));
				
		try {
      
      	this.downloadFile2(await this.http.post(this.globserv.BACKENDBASE+ "/v1/getDocument", data, {responseType: 'blob' }).toPromise());
      	
  		} catch (e) {
  		   
  		   //this.workerWait=false;
      	console.log(e);
  		}
			
  }
  
  downloadFile2(data) 
	{
		  const url = window.URL.createObjectURL(data);
        window.open(url);
  	} 

}
